import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip'

import recordIcon from '../../assets/icons/Icon-Record.svg';
import liveIcon from '../../assets/icons/Icon-Live.svg';
import calendarIcon from '../../assets/icons/Icon-Calendar.svg';
import { SCHEDULE, RECORD, LIVE } from '../../utils/constants';
import { capitalize } from '../../utils/stringManipulations';

const MenuOverlay = ({ isFocused, onItemClick, isOnline }) => {
  return (
    <div className="single-site__image-menu-box__menu" style={{ opacity: isFocused ? 1 : 0 }} data-testid="menu-overlay">
      {isOnline &&
        <Fragment>
          <button
            className="single-site__image-menu-box__menu__icon-wrapper"
            onClick={() => onItemClick(LIVE)}
            data-tip={capitalize(LIVE)}
            data-for={LIVE}
            data-testid="live-button"
          >
            <img src={liveIcon} alt="" />
            <ReactTooltip id={LIVE} />
          </button>
          <div className="single-site__image-menu-box__menu__separator" />
          <button
            className="single-site__image-menu-box__menu__icon-wrapper"
            onClick={() => onItemClick(RECORD)}
            data-tip={capitalize(RECORD)}
            data-for={RECORD}
            data-testid="record-button"
          >
            <img src={recordIcon} alt="" />
            <ReactTooltip id={RECORD} />
          </button>
          <div className="single-site__image-menu-box__menu__separator" />

        </Fragment>
      }
      <button
        className="single-site__image-menu-box__menu__icon-wrapper"
        onClick={() => onItemClick(SCHEDULE)}
        data-tip={capitalize(SCHEDULE)}
        data-for={SCHEDULE}
        data-testid="schedule-button"
      >
        <img src={calendarIcon} alt="" style={{ width: "60%" }} />
        <ReactTooltip id={SCHEDULE} />
      </button>
    </div>
  );
};

MenuOverlay.propTypes = {
  isFocused: PropTypes.bool,
  isOnline: PropTypes.bool,
  onItemClick: PropTypes.func
};

MenuOverlay.defaultProps = {
  isFocused: false,
  isOnline: false,
  onItemClick: () => { }
};

export default MenuOverlay;